export type Camera = {
  id: string,
  vehicleId: string,
  title: string,
  isActive: boolean,
  channel: number,
  ovs_url: string,
  token: string | null
}

export type Vehicle = {
  id: string,
  title: string,
  hasActiveCameras: boolean,
  cams: Camera[]
}

export enum ViewMode {
  active = 1,
  inactive = 2
}

export type AppState = {
  vehicles: Map<string, Vehicle>,
  cameras: Map<string, Camera>,
  selected: Map<string, Camera>,
  searchValue: string,
  viewMode: ViewMode[],
  leftPanelCollapsed: boolean,
  isLoaded: boolean
}
